import { Button, Container, Header, Icon, Segment } from '@mairistem/composants';

const AccessForbiden = (props) => {
  const { onRegiesShow } = props;

  return (
    <Container
      data-testid="access-forbidden-message"
      fluid
      style={{ paddingTop: 100, alignItems: 'center' }}
    >
      <Segment
        basic
        textAlign="center"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Header icon size="large" data-testid="prohibited-message">
          <Icon name="ban" size="massive" />
          Vous n&apos;êtes pas autorisé à accéder à cette page.
          <br />
          <br />
          <Header.Subheader>Veuillez contacter votre administrateur.</Header.Subheader>
        </Header>
        {onRegiesShow && (
          <Button
            data-testid="access-forbidden-regies-show"
            onClick={onRegiesShow}
            className="domain-colored"
          >
            <Icon name="exchange" />
            Changer de régie
          </Button>
        )}
      </Segment>
    </Container>
  );
};

export default AccessForbiden;
